import React from 'react';

import InterviewbitTestDuration from '../InterviewbitTestDuration';
import InterviewbitTestSelect from '../InterviewbitTestSelect';
import styles from './EditGroupContestModalSidePanel.module.scss';

function EditGroupContestModalSidePanel() {
  return (
    <div className={styles.root}>
      <InterviewbitTestDuration />
      <InterviewbitTestSelect />
    </div>
  );
}

export default EditGroupContestModalSidePanel;
